import { ModalBody, ModalHeader } from "reactstrap";
import { getZatcaStatusDisplay, isStandardZatcaDocument, isInternalPurchaseDocument } from "../../../utils/zatcaStatus";

const ZatcaModal = ({ data, setZatcaMod }) => {
  const invoiceDownloadURL = data?.invoice;
  const JsonViewer = ({ jsonData }) => {
    const jsonString = jsonData;

    let prettyJSON = "Invalid JSON";

    const containerStyle = {
      backgroundColor: "#ffffff",
      padding: "15px",
      border: "1px solid #ddd",
      borderRadius: "5px",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      color: "#333",
      width: "80%",
    };

    try {
      const jsonObject = JSON.parse(jsonString);
      prettyJSON = JSON.stringify(jsonObject, null, 2);
    } catch (e) {
      console.error("Error parsing JSON:", e);
    }

    return (
      <div style={containerStyle}>
        <pre>{prettyJSON}</pre>
      </div>
    );
  };

  return (
    <div>
      <ModalHeader toggle={() => setZatcaMod((state) => !state)}>
        Invoice Details
      </ModalHeader>
      <ModalBody>
        <div
          style={{ display: "flex", flexDirection: "column", rowGap: "15px" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5>ZATCA Status</h5>
            <strong>{getZatcaStatusDisplay(data).label}</strong>
          </div>
          {isInternalPurchaseDocument(data) && (
            <p>This purchase document is an internal record and is not submitted to ZATCA.</p>
          )}
          {data?.invoice && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5> Download Invoice</h5>
              <button
                className="border-button"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = invoiceDownloadURL;
                  link.download = `${data?.invoice || "invoice"}.pdf`;
                  link.click();
                }}
              >
                <span> Download Invoice </span>
              </button>
            </div>
          )}
          {data?.signed_xml_url && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5>
                {isStandardZatcaDocument(data) && data?.cleared_xml_url
                  ? "ZATCA Cleared XML"
                  : "Signed XML"}
              </h5>
              <button
                className="border-button"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = data?.signed_xml_url;

                  // Set the download filename with .xml extension
                  const fileName =
                    data?.signed_xml_url
                      ?.split("/")
                      .pop()
                      ?.replace(/\.[^/.]+$/, "") || "invoice";
                  link.download = `${fileName}.xml`;

                  link.click();
                }}
              >
                <span>Download ZATCA Invoice </span>
              </button>
            </div>
          )}
          {data?.xml_url && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5>XML File</h5>
              <button
                className="border-button"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = data?.xml_url;

                  // Set the download filename with .xml extension
                  const fileName =
                    data?.xml_url
                      ?.split("/")
                      .pop()
                      ?.replace(/\.[^/.]+$/, "") || "invoice";
                  link.download = `${fileName}.xml`;

                  link.click();
                }}
              >
                <span> Download XML Invoice</span>
              </button>
            </div>
          )}
          {data?.xml_qrcode && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5>QR Code</h5>
              <button
                className="border-button"
                onClick={() => {
                  if (data?.xml_qrcode) {
                    navigator.clipboard
                      .writeText(data.xml_qrcode)
                      .then(() => {
                        console.log("Copied to clipboard:", data.xml_qrcode);
                        alert("Copied to clipboard!");
                      })
                      .catch((err) => {
                        console.error("Failed to copy:", err);
                      });
                  }
                }}
              >
                <span> Click to Copy</span>
              </button>
            </div>
          )}

          {data?.zatca_response && (
            <div>
              <h5>ZATCA</h5>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <JsonViewer jsonData={data?.zatca_response} />
                <button
                  className="border-button"
                  style={{ flex: "0.5" }}
                  onClick={() => {
                    if (data?.zatca_response) {
                      navigator.clipboard
                        .writeText(data.zatca_response)
                        .then(() => {
                          alert("Copied to clipboard!");
                        })
                        .catch((err) => {
                          console.error("Failed to copy:", err);
                        });
                    }
                  }}
                >
                  <span> Click to Copy</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </ModalBody>
    </div>
  );
};

export default ZatcaModal;
